import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import VendorAllocation from "./vendorAllocation";
import { getVendorList, allocateVendor } from "services/redux/installation/vendorAllocation/action";
import { getSitePrListing } from "services/redux/installation/siteListing/action";

const mapStateToProps = (state) => ({
    vendorList: state.vendorReducer.vendorList,
    vendorAllocate: state.vendorReducer.vendorAllocate,
    sitePrListData: state.siteListingReducer.sitePrListData,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getVendorList,
            allocateVendor,
            getSitePrListing,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(VendorAllocation);
